real.fa = {

    loading : function(fa) {
        if(fa.length === 0) {
            return;
        }

        if(!fa.data('original-classes')) {
            fa.data('original-classes', fa[0].className);
        }

        var classes = fa[0].className.split(' ');
        classes = classes.filter(function(className) {
            if(className === 'fa-fw') {
                // Always keep fa-fw class
                return true;
            }
            return className !== 'fa' && className.substring(0,3) !== 'fa-';
        });
        fa[0].className = classes.join(' ') + ' fa fa-circle-o-notch fa-spin';
    },

    reset : function(fa) {
        if(fa.length === 0 || !fa.data('original-classes')) {
            return;
        }
        fa[0].className = fa.data('original-classes');
        fa.removeData('original-classes');
    }

};
